import React from 'react';
import '../index.css';
import '../output.css';
import { Link, useLocation } from "react-router-dom";

import { IonGrid, IonRow, IonCol } from '@ionic/react';


import HeroThumb from "../assets/images/herothumbnail.png"; // Adjust the path if needed
import fuckthebanks from "../assets/images/fuckthebanks.JPG"; // Adjust the path if needed
import MobileHeroThumb from "../assets/images/mobileherothumbnail.png"; // Adjust the path if needed
import HeroMockup from "../assets/images/UIhero.png"; // Adjust the path if needed
import CommonwealthLogo from '../assets/images/cwealthlogowhite.png';

import { chevronDownOutline } from 'ionicons/icons';
import { useState, useEffect } from 'react';

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < breakpoint);
    checkMobile(); // Check on mount

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [breakpoint]);

  return isMobile;
}

export default function NewHero() {

  const [panelVisible, setPanelVisible] = useState(false);

  const [panelVisiblePlusHalf, setPanelVisiblePlusHalf] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPanelVisible(true);
    }, 1000); // 3s delay

    const timer2 = setTimeout(() => {
      setPanelVisiblePlusHalf(true);
    }, 2000); // 6s delay

    return () => clearTimeout(timer);
  }, []);


  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <section
  style={{
    fontFamily: "Helvetica, sans-serif",
    minHeight: "100vh",
    maxWidth: "100vw",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundColor: "#5FBA8B",
  }}
>
  <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <div>
      <Link to="/home">
        <img
          src={CommonwealthLogo}
          alt="Commonwealth Logo"
          style={{ maxWidth: "40vw", paddingTop: "30px", paddingBottom: "30px", paddingLeft: "6vw" }}
        />
      </Link>
    </div>
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1 }}>
      <img
        src={fuckthebanks}
        style={{ maxWidth: "92vw", height: "auto" }}
      />
    </div>
  </div>
</section>
  );
} else {
    return (

      <section
        className="hero text-black relative overflow-visible"
        style={{
          fontFamily: "Helvetica, sans-serif",
          minHeight: "100vh",
          maxWidth: "100vw",
          //backgroundImage: `url(${burnbank})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          //backgroundPosition: "top center",
          backgroundRepeat: "no-repeat",
          backgroundColor: "#5FBA8B",
        }}
      >
        <IonGrid
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh", // use minHeight so it can grow if needed
          }}
        >
          <IonRow>
            <IonCol>
            <Link to="/home"
            type="button">
              <img
                src={CommonwealthLogo}
                alt="Commonwealth Logo"
                style={{ maxWidth: "20vw", paddingTop: "50px", paddingBottom: "50px", paddingLeft: "8vw", marginTop: "-70px"}}
              />
              </Link>
            </IonCol>
          </IonRow>
          <IonRow style={{display: "flex", justifyContent: "center"}}>
          <img
          src={fuckthebanks}
          style={{maxWidth: "84vw"}}
          />
          </IonRow>

        </IonGrid>
      </section>
    );
  }
}
